import { useState, useEffect } from 'react';
import api from '../api/client.js';

const POLL_MS = 30_000;

export default function useExcedeStatus() {
  const [status, setStatus] = useState({ connected: true, utsccReachable: true, lastSeen: null });

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const { data } = await api.get('/tunnel/status');
        if (!cancelled) setStatus(data);
      } catch {
        if (!cancelled) setStatus(s => ({ ...s, connected: false, utsccReachable: false }));
      }
    }

    check();
    const id = setInterval(check, POLL_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  return status;
}
